<template>
    <div class="ma-formule">
        <div v-if="localFormule.has_subscription_with_anomaly" style="padding: 10px;text-align: center;">
          <h1 style="margin-top: 20px;">Le règlement de votre formule First n'est pas encore validé.</h1>
          <p style="margin-top: 10px;">Il est possible qu'un délai de quelques jours ouvrables soit nécessaire pour la prise en compte de votre règlement.</p>
          <p>Si le problème persiste, merci de contacter notre équipe.</p>
        </div>
        <div v-else>
          <div class="announcement">
            Cherchemonnid pro évolue. Accédez maintenant gratuitement aux coordonées des acquéreurs / vendeurs de votre secteur géographique.
          </div>
          <pricing-table-pro  class="pricing" :mandat="contract.has_contract" :first="localFormule.has_subscription" :authenticated="professional != null"></pricing-table-pro>
          <div class="footer_links" :class="{formula : localFormule.has_subscription}">
            <template v-if="localFormule.has_subscription">
              <template v-if="!localFormule.has_cancelled">
                <a v-if="localFormule.can_cancel" @click="confirmUnsubscribe()"><span class="resiliation">Je souhaite résilier vers une formule Gratuite</span></a>
                <span v-if="localFormule.new_formula && !localFormule.can_cancel" class="resiliation">Vous êtes engagé jusqu'au {{moment(localFormule.discount_end_date).format('D MMMM YYYY')}} inclus.</span>
              </template>
              <div v-else class="resiliation">
                    <span>
                        Formule résiliée,
                        active jusqu'au {{moment(localFormule.end_date).format('D MMMM YYYY')}}.
                    </span>
                <a @click="cancelUnsubscribe()">
                  Annuler ma résiliation
                </a>
              </div>
            </template>
          </div>
        </div>
        <div class="informations">
          <a :href="'/professionnels'" class="more-info">
            <action-button>Plus d'informations</action-button>
          </a>
          <action-button @click="toBeContacted()" colorClass="yellow" iconClass="fa-phone">Contactez-nous</action-button>
        </div>

        <cmn-modal-to-be-contacted ref="toBeContactedModal">
        </cmn-modal-to-be-contacted>

    </div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import CmnModalToBeContacted from '../../components/CmnModal/CmnModalToBeContacted.vue'
import ActionButton from '../Common/ActionButton.vue'
import PricingTablePro from '../../components/PricingTable/pricing-table.vue'

export default {

    name : 'ma-formule',
    components: {
        CmnModalToBeContacted,
        ActionButton,
        PricingTablePro
    },

    data() {
        return {
            moment : moment,
            stripeUnsubscribeUrl : '/api/stripe/unsubscribe',
            stripeCancelUnsubscribeUrl : '/api/stripe/cancel/unsubscribe',
            localFormule : {...this.formule},
        };
    },
    props: {
        formule : Object,
        professional : Object,
        contract : Object
    },
    computed: {

        currentPlan() {
            if(!this.localFormule.has_subscription) {
                return 'freemium';
            }
            if (this.localFormule.new_formula) {
                return this.localFormule.stripe_formula.reference;
            }
            return null;
        }
    },
    methods: {
        confirmUnsubscribe() {
            this.$swal({
                title: "Êtes-vous sûr de vouloir vous désabonner?",
                text: "Vous ne pourrez pas annuler ce changement",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Je me désabonne",
                confirmButtonColor: "#aaa",
                cancelButtonText: "Je reste abonné",
                cancelButtonColor: "#3085d6",
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return axios.get(this.stripeUnsubscribeUrl)
                    .then(response => {
                        return response.data;
                    })
                    .catch(error => {
                        this.$swal("Erreur !", "Une erreur a interrompu la requête", "erreur");
                    });
                },
                allowOutsideClick: () => !this.$swal.isLoading(),
            }).then((res) => {
                if (res.value && res.value.success)
                {
                    this.$swal({
                        type: "success",
                        title: "Votre désinscription a bien été prise en compte",
                    });
                    this.localFormule.has_cancelled = res.value.data.paid === 'cancel';
                    this.localFormule.end_date = res.value.data.current_period_end;
                    this.localFormule.has_subscription = res.value.data.paid !== 'inactive';
                }
                else if(!res.dismiss)
                {
                    this.$swal({
                        type: "warning",
                        title: "Une erreur est survenue",
                        text: "Votre désinscription n'a pas été prise en compte"
                    });
                }
            });
        },
        cancelUnsubscribe() {
            axios.get(this.stripeCancelUnsubscribeUrl)
            .then(res => {
                this.localFormule.has_cancelled = res.data.data.paid === 'cancel';
                this.localFormule.end_date = res.data.data.current_period_end;
                this.$swal({
                    type: "success",
                    title: "Votre résiliation a bien été annulée",
                });
            })
            .catch(err => {
                console.log(err);
            });
        },
        toBeContacted() {
            return this.$refs.toBeContactedModal.open()
        }
    }

}
</script>

<style lang="sass">

    .announcement
      text-align: center
      padding: 20px
      margin-top: 10px
      background-color: #61949B
      color: #FFFFFF
      border-radius: 20px
      font-weight: 700
      font-size: 18px


    .pricing
        margin-top: 20px

    @media (min-width: 1440px)
      .pricing
        padding: 0 10%

    @media (min-width: 1980px)
      .pricing
        padding: 0 20%


    .items-center
        display: flex
        align-items: center

    .ma-formule
        font-family: 'Noto Sans JP', sans-serif
        font-style: normal
        font-size: 14px
        margin-bottom: 20px

        .header-formula
            margin-bottom: 10px

        .informations
            display: flex
            justify-content: center
            margin-top: 40px
            margin-bottom: 5rem

        h1
            font-size: 20px
            font-weight: 500
        h2
            font-size: 14px

        .footer_links
            max-width: 900px
            margin: auto
            display: flex
            font-size: 16px
            margin-top: 30px
            flex-direction: row
            justify-content: center

            .more-info
                display: none

            a
                text-decoration: underline

        @media screen and (min-width: 992px) // desktop
            .footer_links
                justify-content: center
                .more-info
                    display: flex

</style>



// WEBPACK FOOTER //
// application/assets/js/professional/containers/Subscriptions/MaFormule.vue